import Ajax from 'global/od/Ajax';

const nectarFormRequest = (data = {}) =>
	Ajax({
		url: '/ajax/loyalty/checkout/linkLoyaltyScheme',
		method: 'POST',
		dataType: 'html',
		data,
	});

export { nectarFormRequest as default };
